import { RouteState } from "@circuitry-ai/doc-data";
import { PageHeader } from "@circuitry-ai/doc-ui";
import { useNavigate } from "react-router-dom";
import UXGenieWorkerList from "./UXGenieWorkerList";

export interface UXGeniePageProps {
    /** When inside Settings, use this path so Create stays in settings (e.g. /settings/uxgenie) */
    basePath?: string;
}

export function UXGeniePage(props: UXGeniePageProps) {

    const navigate = useNavigate();
    const basePath = props.basePath ?? '/uxgenie';

    return (
        <div className='flex flex-col h-full'>
            <PageHeader
                heading="UXGenie"
                description={'View all your UXGenie Templates at one place.'}
                pageHeaderClass='!px-0'
                showCreateButton={true}
                createButtonText={'Create UXGenie Template'}
                onCreateButtonClick={() => navigate(`${basePath}/${RouteState.CREATE}?tab=configuration`)}
                entityType="uxgenie"
            />
            <div className="flex-1 overflow-y-auto">
                <UXGenieWorkerList basePath={basePath} />
            </div>
        </div>
    );
}


export default UXGeniePage;

